<template>
  <header id="header">
    <b-navbar toggleable type="light" toggle-breakpoint="md">
      <b-nav-toggle target="nav_collapse"></b-nav-toggle>
      <div class="navbar-brand"><img id="header-logo" src="static/assets/images/mfs-logo.png" alt="MKCL ERA"></div>
      <b-collapse is-nav id="nav_collapse">
        <div class="container-fluid">
          <div class="row align-items-center">
              <!-- <div class="offset-lg-4 col-lg-4">
                <div class="header-center menu-alt">
                  <b-link to="#" class="btn">HOME</b-link>
                  <b-link to="/contentupload" class="btn ">CONTENT</b-link>
                  <b-link to="/reportedIssues" class="btn">ISSUES</b-link>
                  <b-link to="/theme" class="btn">HELP</b-link>
                </div>
              </div> -->
              <div class="col-lg-4 offset-md-8 text-right">
            <div class="field">
            <div class="control">
              <div class="select">
                <select v-model="selectedLanguage" @change="changeLanguage">
                  <option disabled>{{ $t('selectLanguage')}}</option>
                  <option>{{$t(headerBar.lblLangEng)}}</option>
                  <option>{{$t(headerBar.lblLangMar)}}</option>
                </select>
              </div>
            </div>
            </div>
          </div>
            <div class="col-lg-4 offset-md-8 text-right">
              <b-dropdown class="box-profile">
                <span slot="text">
                  <div class="profile-text">
                    <span>{{$t(headerBar.lblHello)}}</span>{{username}}
                  </div>
                  <div class="profile-image">
                    <img :src="docImagePath" alt="">
                    <i class="mdi mdi-chevron-down"></i>
                  </div>
                </span>
               <!--  <b-dropdown-header>This is a heading</b-dropdown-header>
                <b-dropdown-item>Action</b-dropdown-item> -->
                 <b-dropdown-item>{{$t(headerBar.lblUserMenu)}}</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="logout()">{{$t(headerBar.lblLogout)}}</b-dropdown-item>
                <!-- <b-dropdown-item @click="gotToMFS()">Go to MFS</b-dropdown-item> -->
                <!-- <b-dropdown-item disabled>Disabled action</b-dropdown-item> -->
              </b-dropdown>
            </div>
          </div>
        </div>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
// import Vue from 'vue'
import axios from 'axios'
export default {
  name: 'mfs-header',
  props: ['menu'],
  data () {
    return {
      username: '',
      docImagePath: 'static/assets/images/dummy.png',
      selectedLanguage: this.$t('selectLanguage')
    }
  },
  mounted () {
    this.getUserDetails()
  },
  methods: {
    getUserDetails () {
      var self = this
      axios.get('/r/entry/getUserDetails/' + this.$store.state.candidateProfile.profileUser).then(response => {
        if (response.data !== null) {
          this.$store.commit('STORE_PROFILE_USER_DETAILS', response.data)
          if (this.$store.state.user.userDetails.personalDetails !== undefined) {
            for (let docImage = 0; docImage < this.$store.state.user.userDetails.documents.length; docImage++) {
              if (this.$store.state.user.userDetails.documents[docImage].docId === this.$store.state.candidateProfile.profileUser + '_ProfilePicture') {
                this.docImagePath = this.$store.state.user.userDetails.documents[docImage].docImage
                break
              } else {
                this.docImagePath = 'static/assets/images/dummy.png'
              }
            }
            this.username = this.$store.state.user.userDetails.personalDetails.fullName
          }
        }
      }).catch(e => {
        this.$toasted.error(self.$t('toastr.toastrSomethingWentWrong'), {
          theme: 'bubble',
          duration: this.TOASTR_TIME
        })
      })
    },
    gotToMFS () {
      window.MKCLAPI.switchAppWithSingleSignOn(this.MFS_CLIENT_ID)
    },
    changeLanguage () {
      if (this.selectedLanguage === 'English') {
        this.$i18n.set('en')
      } else if (this.selectedLanguage === 'Marathi') {
        this.$i18n.set('mr')
      }
    },
    logout () {
      window.MKCLAPI.logout()
      this.$toasted.success(this.$t('headerBar.tostrLogout'), { theme: 'bubble', duration: this.TOASTR_TIME })
      this.$router.push('/')
      // window.location.href('http://localhost:8088/?#/')
    }
    // logout () {
    //   axios
    //     .post('/r/c/lcmslogin/logout')
    //     .then(response => {
    //       // console.log('response = ' + JSON.stringify(response))
    //       // if (response != null && !response.data) {
    //       //   console.log('Err while logout')
    //       //   this.$toasted.error('Oops! Something went wrong, Please Try again.', { theme: 'bubble', duration: 6000 })
    //       // } else {
    //       Vue.toasted.success('Logout succesfully!', { theme: 'bubble', duration: 6000 })
    //       this.$store.commit('STORE_CLEAR_ALL')
    //       sessionStorage.removeItem('authorization')
    //       this.$router.push({ name: 'Logout' })
    //       // }
    //     })
    //     .catch(e => {
    //       console.log(e)
    //       // this.$toasted.error('Oops! Something went wrong, Please Try again.', { theme: 'bubble', duration: 6000 })
    //       Vue.toasted.error('Oops! Something went wrong, Please Try again.', { theme: 'bubble', duration: 6000 })
    //       this.$store.commit('STORE_CLEAR_ALL')
    //       sessionStorage.removeItem('authorization')
    //       this.$router.push({ name: 'Logout' })
    //     })
    // }
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';

#header {
  padding-bottom:10px;
  margin-bottom:50px;
  padding: 0;
  /* height: 66px;*/
  border-bottom: 1px solid #ebebeb;
  background: #fff;
  .container-fluid{
    padding-right:0px;
  }
  .show>.btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #fff;
    border-color: #fff;
}

.menuitem{
  a{ &:active, &:focus{background-color:rgb(72, 133, 237); color:#fff;}}
}
.dropdown-toggle{
  border:none;
  outline:none;
  box-shadow: none;
  background-color:#fff;
  &:focus, &:active{
    background-color:#fff;
  }
}
.dropdown-toggle::after{
  color:#777;
}
  #header-logo {
    padding: 12px 20px;
    height: 70px;
  }
  .header-left {
    padding-left: 0;
  }
  .header-center {
    text-align: center;
  }
  .header-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .navbar {
    position: relative;
    // padding: 0;
  }
  .navbar-brand {
    padding-top: 0;
    padding-bottom: 0;
    cursor: pointer;
  }
  .navbar-collapse .container-fluid {
    width: 100%;
  }
  .navbar-toggler-right {
    top: 13px;
  }

  .btn {
    border-radius: 0;
    transform: scale3d(1, 1, 1); 
    &:active {transform: scale3d(1,1,1);}
  }
}

.menu-alt {
  .btn {
    padding: 21px 15px;
    border: none;
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    color: #989d9f;
    // &:hover,
    // &:focus {
    //   // background: $gray;
    // }
    &.active {
      color: #333;
      background: #fff;
      box-shadow: inset 0 -3px 0 0 $pricolor;
    }
  }
}

.box-action {
  text-align: center;
  .btn {
    position: relative;
    padding: 21px 15px;
    border: none;
    font-size: 24px;
    line-height: 24px;
    color: #b2b7bc/*#ced3d7*/
    ;
    &:hover,
    &:focus {
      // background: $gray;
    }
  }
  .indicator {
    position: absolute;
    top: 6px;
    right: 3px;
    width: 16px;
    height: 16px;
    border-radius: 30px;
    font-size: 10px;
    line-height: 15px;
    font-weight: 700;
    color: #fff;
    background: $pricolor;
  }
}

.box-profile {
  justify-content: center;
  >.btn {
    border: none;
    // display: flex;
    // flex-direction: row;
    align-items: center;
    background: transparent;
    // &:hover,
    // &:focus {
    //   // background: $gray;
    // }
    >span {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }
  .profile-image {
    margin-left: 10px;
    width: 40px;
    height: 40px;
    border-radius: 60px;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  .profile-text {
    font-size: 13px;
    font-weight: 600;
    text-align: right;
    color: #333;
    span {
      display: block;
      font-size: 11px;
      font-weight: 400;
      color: #777;
    }
  }

  .dropdown-menu {
    left: 50%;
    margin-left: -120px;
    width: 240px;
  }
}


// ========= RESPONSIVENESS
@media (min-width: 576px) {
  #header {
    .header-right {
      flex-direction: row;
    }
  }

  .box-action {
    margin-right: 20px;
  }
  .box-profile {
    .dropdown-menu {
      left: auto;
      right: 0;
      margin-left: 0;
    }
  }
}

@media (min-width: 768px) {}

@media (min-width: 992px) {
  #header {
    .header-right {
      padding-right: 0;
    }
    .navbar-brand {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
    }
  }

  .box-action {
    margin-left: auto;
    margin-right: 20px;
    .btn {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}

@media (min-width: 1200px) {
  .box-action {
    margin-right: 40px;
    .btn {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/mfs-header.vue